/**
 * 参考文档：
 * https://developers.facebook.com/docs/facebook-pixel/reference#standard-events
 * https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking#standard-events
 */

// 基础代码
function FbPixelBaseCode() {
	if (!import.meta.client) return;

	!(function (f, b, e, v, n, t, s) {
		if (f.fbq) return;
		n = f.fbq = function () {
			n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
		};
		if (!f._fbq) f._fbq = n;
		n.push = n;
		n.loaded = !0;
		n.version = "2.0";
		n.queue = [];
		t = b.createElement(e);
		t.async = !0;
		t.src = v;
		s = b.getElementsByTagName(e)[0];
		s.parentNode.insertBefore(t, s);
	})(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
}

// 初始化
export function initFbPixel(idList) {
	if (!import.meta.client) return;
	if (!idList || idList.length === 0) return;

	let timer = null;
	let num = 0;

	if (location.pathname.indexOf("/index") > -1) {
		num = 1000;
	}
	let timeHandle = () => {
		timer = setTimeout(() => {
			FbPixelBaseCode();

			idList.map(v => {
				fbq && fbq("init", v);
				console.log("fb初始化", v);
			});
			fbq("track", "PageView");

			clearTimeout(timer);
		}, num);
	};
	timeHandle();
}

// 购买事件上报
export function resultFbPixelCode(fbPrice, orderId, currency) {
	if (!import.meta.client) return;
	if (!window.fbq) return;

	// fb标准事件-购买完成追踪
	let timer = null;
	let timeHandle = () => {
		timer = setTimeout(() => {
			fbq &&
				fbq(
					"track",
					"Purchase",
					{
						content_name: orderId, // 頁面／產品名稱，订单号
						value: fbPrice,
						currency: currency || "USD", //货币单位
					},
					{ eventID: `${orderId}Purchase` }
				);
			console.log("facebook event Purchase");
			clearTimeout(timer);
		}, 1000);
	};
	timeHandle();
}

// 拍照
export function fbTrack(evenName) {
	if (!import.meta.client) return;
	if (window.fbq) {
		fbq("track", evenName);
	}
}
